/** @jsxImportSource theme-ui @jsxRuntime classic */
import React from 'react';

import { Box, Text } from '..';

export interface ReviewCarouselCardProps {
  quote: string;

  author: string;

  quoteSize?: 'large' | 'medium';
}

/**
 * `ReviewCarouselCard` displays social media images
 * which are currently being pulled from Curator.io
 *  It can be used as an item in a Carousel, or by itself.
 *
 * @see https://tishman.netlify.app/components/carousel
 */

export function ReviewCarouselCard({
  quote,
  author,
  quoteSize = 'large',
}: ReviewCarouselCardProps): React.JSX.Element {
  return (
    <Box sx={{ maxWidth: 900 }}>
      <Text
        sx={{
          variant: 'text.heading',
          fontFamily: 'headingSecondary',
          color: 'text',
          fontSize: quoteSize === 'large' ? [6, 8] : ['24px', '40px'],
          fontWeight: quoteSize === 'large' ? 'heading' : 'regular',
          letterSpacing: quoteSize === 'large' ? 0 : ['-0.52px', '-1px'],
          lineHeight: quoteSize === 'large' ? 'heading' : ['33px', '64px'],
          mb: 4,
        }}
      >
        {quote}
      </Text>
      <Text
        sx={{
          variant: 'text.heading',
          fontFamily: 'headingSecondary',
          color: 'text',
          fontSize: quoteSize === 'large' ? [2, 5] : ['20px', '25px'],
          fontWeight: quoteSize === 'large' ? 'heading' : 'regular',
          letterSpacing: quoteSize === 'large' ? 1 : ['-0.52px', '-1px'],
          lineHeight: quoteSize === 'large' ? 'heading' : ['33px', '38px'],
          mb: quoteSize === 'large' ? 4 : 0,
        }}
      >
        {`—${author}`}
      </Text>
    </Box>
  );
}
